import { AuthRequirement } from '../../pages/routes'
import { RouteLink } from '../../utils/constants/router-link'
type AuthRequirementResponse = [boolean, RouteLink, never?]

export const AUTH_REQUIREMENTS: Record<
    AuthRequirement,
    () => AuthRequirementResponse
> = {
    [AuthRequirement.AUTHENTICATED]() {
        return [false, RouteLink.ERROR] as AuthRequirementResponse
    },

    [AuthRequirement.UNAUTHENTICATED]() {
        return [true, RouteLink.ERROR]
    },
}
